import { InjectionToken, Component, Inject, Input, HostBinding, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["onepIcon", ""];
const ONEP_ICON_SVG_PATH = new InjectionToken('ONEP_ICON_SVG_PATH');

/**
 * Component that displays a svg icon
 */
class IconComponent {
    constructor(iconSvgPath) {
        this.iconSvgPath = iconSvgPath;
        this.wiClass = true;
    }
    ngOnInit() { }
    ngOnChanges() { }
}
IconComponent.ɵfac = function IconComponent_Factory(t) { return new (t || IconComponent)(ɵngcc0.ɵɵdirectiveInject(ONEP_ICON_SVG_PATH)); };
IconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: IconComponent, selectors: [["svg", "onepIcon", ""]], hostVars: 2, hostBindings: function IconComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("wi", ctx.wiClass);
    } }, inputs: { wiClass: "wiClass", iconName: ["onepIcon", "iconName"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c0, decls: 1, vars: 1, template: function IconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(0, "use");
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("href", ctx.iconSvgPath + "#" + ctx.iconName);
    } } });
IconComponent.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [ONEP_ICON_SVG_PATH,] }] }
];
IconComponent.propDecorators = {
    iconName: [{ type: Input, args: ['onepIcon',] }],
    wiClass: [{ type: HostBinding, args: ['class.wi',] }, { type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconComponent, [{
        type: Component,
        args: [{ selector: 'svg[onepIcon]', template: "<svg:use [attr.href]=\"iconSvgPath + '#' + iconName\"></svg:use>\n" }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [ONEP_ICON_SVG_PATH]
            }] }]; }, { wiClass: [{
            type: HostBinding,
            args: ['class.wi']
        }, {
            type: Input
        }], iconName: [{
            type: Input,
            args: ['onepIcon']
        }] }); })();

/**
 * Component that wraps the icon minus or plus with a highlighted circle
 */
class IconCircleHighlightedComponent {
    constructor() {
        /**
         * Defines the icon's name
         */
        // tslint:disable-next-line:no-input-rename
        this.iconName = 'plus';
        /**
         * Defines the icon's size
         */
        // tslint:disable-next-line:no-input-rename
        this.size = 24;
        this.width = this.size;
        this.height = this.size;
        this.IconCircleHighlightedClass = true;
    }
    ngOnInit() {
        this.width = this.size;
        this.height = this.size;
    }
}
IconCircleHighlightedComponent.ɵfac = function IconCircleHighlightedComponent_Factory(t) { return new (t || IconCircleHighlightedComponent)(); };
IconCircleHighlightedComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: IconCircleHighlightedComponent, selectors: [["onep-icon-circle-highlighted"]], hostVars: 6, hostBindings: function IconCircleHighlightedComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.width, "px")("height", ctx.height, "px");
        ɵngcc0.ɵɵclassProp("onep-icon-circle-highlighted", ctx.IconCircleHighlightedClass);
    } }, inputs: { iconName: ["onepIcon", "iconName"], size: "size" }, decls: 2, vars: 9, consts: [[3, "onepIcon"], [1, "onep-icon-circle"]], template: function IconCircleHighlightedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(0, "svg", 0);
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelement(1, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("font-size", ctx.size, "px");
        ɵngcc0.ɵɵproperty("onepIcon", ctx.iconName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.size - 8, "px")("height", ctx.size - 8, "px")("margin", 4, "px");
    } }, dependencies: [IconComponent] });
IconCircleHighlightedComponent.ctorParameters = () => [];
IconCircleHighlightedComponent.propDecorators = {
    iconName: [{ type: Input, args: ['onepIcon',] }],
    size: [{ type: Input, args: ['size',] }],
    width: [{ type: HostBinding, args: ['style.width.px',] }],
    height: [{ type: HostBinding, args: ['style.height.px',] }],
    IconCircleHighlightedClass: [{ type: HostBinding, args: ['class.onep-icon-circle-highlighted',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconCircleHighlightedComponent, [{
        type: Component,
        args: [{ selector: 'onep-icon-circle-highlighted', template: "<svg [style.fontSize.px]=\"size\" [onepIcon]=\"iconName\"></svg>\n<div\n  class=\"onep-icon-circle\"\n  [style.width.px]=\"size - 8\"\n  [style.height.px]=\"size - 8\"\n  [style.margin.px]=\"4\"\n></div>\n" }]
    }], function () { return []; }, { iconName: [{
            type: Input,
            args: ['onepIcon']
        }], size: [{
            type: Input,
            args: ['size']
        }], width: [{
            type: HostBinding,
            args: ['style.width.px']
        }], height: [{
            type: HostBinding,
            args: ['style.height.px']
        }], IconCircleHighlightedClass: [{
            type: HostBinding,
            args: ['class.onep-icon-circle-highlighted']
        }] }); })();

/**
 * Module that provides the icon component.
 */
class IconModule {
}
IconModule.ɵfac = function IconModule_Factory(t) { return new (t || IconModule)(); };
IconModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: IconModule });
IconModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconModule, [{
        type: NgModule,
        args: [{
                declarations: [IconComponent, IconCircleHighlightedComponent],
                imports: [CommonModule],
                exports: [IconComponent, IconCircleHighlightedComponent],
                schemas: [NO_ERRORS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IconModule, { declarations: function () { return [IconComponent, IconCircleHighlightedComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [IconComponent, IconCircleHighlightedComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { IconCircleHighlightedComponent, IconComponent, IconModule, ONEP_ICON_SVG_PATH };

